import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { GlobalSpinnerState } from './global-spinner.state';
import { globalSpinnerActions } from './global-spinner.actions';

const initialState: GlobalSpinnerState = {
  requestsCount: 0,
};

export const globalSpinnerFeature = createFeature({
  name: 'globalSpinner',
  reducer: createReducer(
    initialState,
    on(globalSpinnerActions.request, (state) => ({
      ...state,
      requestsCount: Math.min(state.requestsCount + 1, Number.MAX_SAFE_INTEGER),
    })),
    on(globalSpinnerActions.dispose, (state) => ({
      ...state,
      requestsCount: Math.max(state.requestsCount - 1, 0),
    })),
  ),
  extraSelectors: self => {
    const selectIsGlobalSpinnerVisible = createSelector(
      self.selectRequestsCount,
      (requestCount) => requestCount > 0,
    );

    return {
      selectIsGlobalSpinnerVisible,
    };
  },
});
